var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 28,
    viewBox: "0 0 181 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 28,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-160 -240)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.371 21.6489H94.8623L98.1156 16.3914L101.371 11.1351L104.625 16.3914L107.877 21.6489H101.371ZM102.687 9.14482L103.645 7.34197L115.985 27.1517H118.175L109.773 13.5753L103.533 3.49432L92.53 21.6262L90.4497 21.6489L102.489 1.80734L101.371 -3.8147e-05L92.969 13.5753L86.8968 23.3847H108.646L109.725 25.1205H85.8215L84.5657 27.1517H101.371H113.904L102.687 9.14482Z",
    fill: "url(#paint0_radial_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4279 17.0596L4.52662 15.5828L3.63652 17.0596H5.4279ZM0 20.5051L4.52662 13.007L9.08561 20.5051H7.50901L6.15699 18.2535L2.90698 18.2637L1.55565 20.5051H0Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1919 20.5051V13.007H13.5544V19.2589H19.6253V20.5051H12.1919Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7327 20.5051V13.007H24.0952V19.2589H30.1658V20.5051H22.7327Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6362 13.007V20.5051H33.2737V13.007H34.6362Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1835 17.0596L42.2825 15.5828L41.3921 17.0596H43.1835ZM37.7556 20.5051L42.2825 13.007L46.8409 20.5051H45.2644L43.9123 18.2535L40.6625 18.2637L39.3112 20.5051H37.7556Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9482 20.5051V13.007H50.9889L56.5129 18.4001V13.007H57.8963V20.5051H56.8345L51.3212 15.1011L51.3107 20.5051H49.9482Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3512 15.4885L68.2761 15.3528C68.2445 15.2897 68.2231 15.2272 68.1903 15.1745L68.1045 15.0386C68.0831 14.9966 68.0509 14.9654 67.9979 14.9234C67.4611 14.3577 66.3132 14.2423 65.4768 14.2423C63.353 14.2423 62.3879 14.8291 62.3879 16.7456C62.3879 18.6723 63.353 19.2589 65.4768 19.2589C66.3132 19.2589 67.4611 19.1437 67.9979 18.5886C68.0509 18.5364 68.0831 18.5046 68.1045 18.4732C68.126 18.4314 68.148 18.3898 68.1903 18.3371C68.2231 18.2849 68.2445 18.2115 68.2761 18.1592L68.3512 18.002L69.3704 18.9449L69.3383 19.0074C69.2096 19.2278 69.0482 19.4266 68.8557 19.594C68.0187 20.2956 66.5383 20.4949 65.4768 20.4949C62.6232 20.4949 61.0034 19.3743 61.0034 16.7456C61.0034 14.1377 62.6232 13.007 65.4768 13.007C66.5383 13.007 68.0187 13.2058 68.8557 13.9071C69.0482 14.0746 69.2096 14.2741 69.3383 14.4831L69.3704 14.5569L68.3512 15.4885Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4838 16.002V17.2482H73.8502V19.2589H79.9207V20.5051H72.4878V13.007H79.9207V14.2634H73.8502V16.002H78.4838Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.139 15.5124L130.064 15.3768C130.032 15.3136 130.011 15.2511 129.978 15.1984L129.893 15.0625C129.871 15.0205 129.839 14.9894 129.785 14.9471C129.249 14.3816 128.101 14.2662 127.264 14.2662C125.14 14.2662 124.175 14.8531 124.175 16.7695C124.175 18.6962 125.14 19.2828 127.264 19.2828C128.101 19.2828 129.249 19.1677 129.785 18.6126C129.839 18.5603 129.871 18.5285 129.893 18.4974C129.914 18.4553 129.936 18.4138 129.978 18.361C130.011 18.3088 130.032 18.2354 130.064 18.1832L130.139 18.026L131.159 18.9689L131.126 19.0313C130.997 19.2517 130.836 19.4505 130.643 19.618C129.806 20.3195 128.326 20.5188 127.264 20.5188C124.411 20.5188 122.792 19.3982 122.792 16.7695C122.792 14.1617 124.411 13.0309 127.264 13.0309C128.326 13.0309 129.806 13.2297 130.643 13.9311C130.836 14.0987 130.997 14.298 131.126 14.5071L131.159 14.5809L130.139 15.5124Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.028 16.2981C139.939 16.2981 140.734 16.2769 140.734 15.4079V15.1462C140.734 14.6854 140.487 14.4759 140.154 14.3714C139.972 14.3191 139.768 14.2873 139.553 14.2873C139.328 14.2662 139.103 14.2771 138.888 14.2771H135.638V16.2981H139.028ZM138.834 13.0309C140.454 13.0309 142.107 13.2927 142.107 15.1359V15.429C142.107 16.8738 141.077 17.3977 139.693 17.5231L142.653 20.5291H140.809L137.88 17.5443H135.649L135.66 20.5291H134.276V13.0309H138.834Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.767 16.0259V17.2721H147.133V19.2828H153.205V20.5291H145.771V13.0309H153.205V14.2873H147.133V16.0259H151.767Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.045 19.2931C160.935 19.2931 162.019 19.1465 162.555 18.5081C162.941 18.0469 163.027 17.3664 163.027 16.7695C163.027 16.1826 162.941 15.5124 162.555 15.0519C162.019 14.4128 160.935 14.2662 160.045 14.2662H157.685V19.2931H160.045ZM160.045 13.0309C161.343 13.0309 162.823 13.3135 163.66 14.3191C164.25 15.0308 164.41 15.9527 164.41 16.7904C164.41 19.3249 162.856 20.5291 160.045 20.5291H156.323V13.0309H160.045Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.89 13.0309V20.5291H167.528V13.0309H168.89Z",
    fill: "#21598A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.687 20.5291H175.315L175.325 14.2771H172.011V13.0309H180.002V14.2771H176.687V20.5291Z",
    fill: "#21598A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.371 13.5758) scale(15.4229 19.5755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30B3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109076,
    stopColor: "#31B3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115613,
    stopColor: "#34B5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210598,
    stopColor: "#23ADC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81743,
    stopColor: "#21598A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21598A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-160 -240)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.751bd2d6c4df29ba1a76e46ff553fcaa.svg";
export { ForwardRef as ReactComponent };